import React from "react";
import styled from "styled-components";
import fetch from "./shared/Fetch";
import AppHeading from "./sharedComponents/AppHeading";
import Table from "./sharedComponents/Table";
import ReportHeading from "./sharedComponents/ReportHeading";
import { SumData } from "./Consultants";
import { formatNoFraction } from "./shared/NumberUtil";
import Spinner from "./sharedComponents/Spinner";
import FilteringBar from "./sharedComponents/FilteringBar";
import {
  FilteringBarContainer,
  FilterSidebarContainer,
  FilterIconStyled,
  FilterButton,
  CloseButton,
  CloseIconStyled,
  MainLayout
} from "./sharedComponents/FilterSidebar";

const ReportContainer = styled.div`
  padding: 0 5rem 5rem;
  width: 100%;

  @media (max-width: 900px) {
    padding: 0 2rem 5rem;
  }
  @media (max-width: 750px) {
    padding: 0 1rem 5rem;
  }
`;

const LeadingHeading = styled.td`
  padding: 0.5rem;
  text-align: left;
`;

const ReportTables = styled.div`
  border-collapse: collapse;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 5rem;
`;

const TableContainer = styled.div``;

const SumRow = styled.tr`
  font-weight: bold;
  &:nth-child(2n) {
    background: var(--table-band-background);
  }
`;

class Insights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      budget: [],
      months: [],
      yearWeeks: [],
      reportHeading: "Konsulent",
      monthOffset: 0,
      waitingForData: true,
      isFilterOpen: false,
      seniorityOrderToId: {}
    };
  }

  componentDidMount() {
    this.fetchInsights();
    this.fetchSenioritiesMap();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.match.params.offset !== prevProps.match.params.offset ||
      this.props.match.params.weeks !== prevProps.match.params.weeks
    ) {
      this.fetchInsights();
    }
  }

  render() {
    const {
      departmentBillRate,
      groupBillRate,
      seniorityBillRate,
      yearWeeks,
      waitingForData,
      isFilterOpen,
      seniorityOrderToId
    } = this.state;

    const {
      departments,
      offset,
      weeks,
      groups,
      seniorities,
      serviceareas
    } = this.props.match.params;

    const groupsArray = groups === "all" ? [] : groups ? groups.split(",") : [];
    const departmentsArray =
      departments === "all" ? [] : departments ? departments.split(",") : [];

    const senioritiesArray =
      seniorities === "all" ? [] : seniorities ? seniorities.split(",") : [];

    const serviceareasArray =
      serviceareas === "all" ? [] : serviceareas ? serviceareas.split(",") : [];

    const filterByIds = (arr, selected) => {
      if (!arr) return [];
      if (!selected || selected.length === 0) return arr;
      const set = new Set(selected.map(String));
      return arr.filter(item => set.has(String(item.id)));
    };
    filterByIds(departmentBillRate || [], departmentsArray);
    filterByIds(groupBillRate || [], groupsArray);

    let seniorityFiltered = seniorityBillRate || [];
    if (senioritiesArray && senioritiesArray.length > 0) {
      const allowedIds = new Set(
        senioritiesArray
          .map(order => seniorityOrderToId[String(order)])
          .filter(id => id !== undefined)
          .map(id => String(id))
      );
      if (allowedIds.size > 0) {
        seniorityFiltered.filter(item => allowedIds.has(String(item.id)));
      }
    }

    return (
      <div className="module">
        <AppHeading
          departments={departments}
          offset={this.props.match.params.offset}
          weeks={weeks}
          groups={groups}
          availableOnly={this.props.match.params.availableOnly}
          seniorities={seniorities}
          serviceareas={serviceareas}
          active={"report"}
        />

        <FilterSidebarContainer isOpen={isFilterOpen}>
          <CloseButton
            onClick={() =>
              this.setState({
                isFilterOpen: false
              })
            }
          >
            <CloseIconStyled />
          </CloseButton>
          <FilteringBar
            selectedDepartments={departmentsArray}
            selectedGroups={groupsArray}
            selectedSeniorities={senioritiesArray}
            selectedServiceAreas={serviceareasArray}
            closeFilter={() => this.setState({ isFilterOpen: false })}
            applyFilter={this.fetchInsights.bind(this)}
          />
        </FilterSidebarContainer>
        <MainLayout sidebarOpen={isFilterOpen}>
          <ReportContainer>
            <ReportHeading
              departments={departments}
              offset={offset}
              weeks={weeks}
              groups={groups}
              availableOnly={this.props.match.params.availableOnly}
              seniorities={seniorities}
              serviceareas={serviceareas}
            />
            <Spinner show={waitingForData} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "1rem"
              }}
            >
              <FilteringBarContainer>
                <h3 className="page-heading">Innsikt faktureringsgrad</h3>
                <FilterButton
                  onClick={() =>
                    this.setState({
                      isFilterOpen: !isFilterOpen
                    })
                  }
                >
                  <FilterIconStyled />
                </FilterButton>
              </FilteringBarContainer>
            </div>
            <ReportTables>
              {departmentBillRate && (
                <InsightTable
                  heading="Lokasjon"
                  data={departmentBillRate}
                  yearWeeks={yearWeeks}
                  params={this.props.match.params}
                  showControls={true}
                  largeLeadingHeader={true}
                />
              )}

              {groupBillRate && (
                <InsightTable
                  heading="Tjeneste"
                  data={groupBillRate}
                  yearWeeks={yearWeeks}
                  params={this.props.match.params}
                  showControls={false}
                  largeLeadingHeader={true}
                />
              )}

              {seniorityBillRate && (
                <InsightTable
                  heading="Stillingsnivå"
                  data={seniorityBillRate}
                  yearWeeks={yearWeeks}
                  params={this.props.match.params}
                  showControls={false}
                  largeLeadingHeader={true}
                />
              )}
            </ReportTables>
          </ReportContainer>
        </MainLayout>
      </div>
    );
  }

  fetchInsights() {
    this.setState({ waitingForData: true });
    let offset = this.props.match.params.offset;
    if (!offset) offset = 0;

    let weeks = this.props.match.params.weeks;
    if (!weeks) weeks = 8;

    const departmentsStringRaw = this.props.match.params.departments || "";
    const groupsString = this.props.match.params.groups || "";
    const seniorityString = this.props.match.params.seniorities || "";
    const serviceareasString = this.props.match.params.serviceareas || "";

    const departmentsQuery =
      departmentsStringRaw === "all" ? "" : departmentsStringRaw;

    fetch(
      `/insights/offset/${offset}/weeks/${weeks}?departments=${departmentsQuery}&groups=${
        groupsString === "all" ? "" : groupsString
      }&seniorities=${
        seniorityString === "all" ? "" : seniorityString
      }&serviceareas=${serviceareasString === "all" ? "" : serviceareasString}`
    )
      .then(response => {
        const yearWeeks =
          response.departmentBillRates.length > 0
            ? response.departmentBillRates[0].billableRate.map(
                week => week.yearWeek
              )
            : [];

        this.setState({
          departmentBillRate: response.departmentBillRates,
          groupBillRate: response.groupBillRates,
          seniorityBillRate: response.seniorityBillRates,
          yearWeeks: yearWeeks,
          waitingForData: false
        });
      })
      .catch(() => {
        this.setState({ waitingForData: false });
        console.log("Something went wrong while fetching seniorities");
      });
  }

  fetchSenioritiesMap() {
    fetch(`/seniorities`)
      .then(res => {
        const map = {};
        res.forEach(s => {
          if (s.order !== undefined && s.id !== undefined) {
            map[String(s.order)] = s.id;
          }
        });
        this.setState({ seniorityOrderToId: map });
      })
      .catch(err => {
        console.log("Something went wrong while fetching seniorities map", err);
      });
  }
}

export default Insights;

function InsightTable({
  heading,
  data,
  yearWeeks,
  params,
  showControls = true,
  largeLeadingHeader = true
}) {
  return (
    <TableContainer>
      <Table
        yearWeeks={yearWeeks}
        params={params}
        inner="insights"
        leadingHeaders={[heading]}
        hideOverflowFirstColumn={true}
        showControls={showControls}
        largeLeadingHeader={largeLeadingHeader}
      >
        {data.map(item => (
          <SumRow key={item.id}>
            <LeadingHeading title={item.name}>{item.name}</LeadingHeading>
            {item.billableRate.map((rate, i) => (
              <SumData key={i}>
                {formatNoFraction(rate.billableRate * 100)} %
              </SumData>
            ))}
          </SumRow>
        ))}
      </Table>
    </TableContainer>
  );
}
